import { render, staticRenderFns } from "./relatorioAdministrativo.vue?vue&type=template&id=6f920a0f&scoped=true"
import script from "./relatorioAdministrativo.vue?vue&type=script&lang=js"
export * from "./relatorioAdministrativo.vue?vue&type=script&lang=js"
import style0 from "./relatorioAdministrativo.vue?vue&type=style&index=0&id=6f920a0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f920a0f",
  null
  
)

export default component.exports